import React from 'react';
import PropTypes from 'prop-types';
import ReactSwitch from 'react-switch';
import cn from 'classnames';

import Hint from '../Hint';

import s from './Toggle.module.css';

const Toggle = ({ checked, onColor, onChange, label, labelClassName, className, hintText, ...rest }) => (
  <label className={className}>
    <span className={cn(s.labelTitle, labelClassName)}>
      {label}
      {hintText && <Hint className={s.hint} text={hintText} />}
    </span>
    <ReactSwitch
      onColor={onColor}
      offColor={'#1f2431'}
      handleDiameter={24}
      height={28}
      width={54}
      uncheckedIcon={false}
      checkedIcon={false}
      onChange={onChange}
      checked={checked}
      {...rest}
    />
  </label>
);

Toggle.defaultProps = {
  checked: false,
  onColor: '#0bc487',
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  onColor: PropTypes.string,
};

export default Toggle;
